export default `
  <style>
    .summary-template--wrapper,
    .notification-template--wrapper {
      padding: 25px 20px;
      background: #F1F2F3;
      width: 560px;
      margin: 0 auto;
    }

    .notification-container--first-line {
      font-size: 13px;
      margin-bottom: 15px;
      height: 15px;
    }

    .notification-container--first-line-date {
      float: right;
      color: #6E5BEA;
    }

    .notification-container--first-line-shop {
      font-size: 12px;
      font-weight: 500;
      color: #000001;
      float: left;
    }

    .product-container--left-block {
      width:49%;
      display: inline-block;
      vertical-align: top;
    }

    .product-container--right-block {
      width:49%;
      display: inline-block;
      vertical-align: middle
    }


    .product-container--image {
      width: 188px;
      height: 188px;
      border-radius: 20px;
      border: 1px solid #DFE3E8;
      overflow: hidden;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    .product-container--image-desktop {
      display: block;
    }

    .product-container--image-mobile {
      display: none;
    }

    .notification-container--wrapper {
      margin-bottom: 30px;
      line-height: 120%;
      border-radius: 5px;
      padding: 32px;
      background: linear-gradient(60deg, rgba(3, 198, 230, 0.1) 0.63%, rgba(76, 99, 241, 0.1) 20.38%, rgba(110, 91, 234, 0.1) 40.13%, rgba(180, 104, 209, 0.1) 59.88%, rgba(217, 124, 194, 0.1) 79.62%, rgba(241, 137, 184, 0.1) 99.37%);
    }

    .logo-container--wrapper {
      padding: 20px 30px;
      border-radius: 5px;
      background: #FFF;
      margin-bottom: 30px;
    }

    .product-list-container--links-wrapper {
      width: 100%;
      text-wrap: nowrap;
      margin-bottom: 20px;
    }

    .product-list-container--links-title {
      display: inline-block;
      width: 24%;
    }

    .product-list-container--links-actions {
      display: inline-block;
      width: 75%;
      text-align: right;
    }

    .product-list-container--link {
      display: inline-block;
      padding: 8px 16px;
      border-radius: 10px;
      background: #6E5BEA;
      color: #FFF !important;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      margin-left: 15px;
    }

    .notification-container--desktop-links {
      text-wrap: nowrap;
      display: block;
    }

    .notification-container--mobile-links {
      text-wrap: nowrap;
      display: none;
    }

    .product-list-container--title-cell {
      max-width: 200px;
    }

    .footer-container {
      text-align: center;
      background: #FAFAFA;
      padding: 25px 20px;
      width: 560px;
      margin: 0 auto;
    }

    @media only screen and (max-width:560px) {
      .footer-container,
      .summary-template--wrapper,
      .notification-template--wrapper {
        width: 320px;
      }


      .notification-container--first-line {
        height: auto;
      }
  
      .notification-container--first-line-date {
        display: block;
        margin-bottom: 10px;
        width: 100%;
      }
  
      .notification-container--first-line-shop {
        float: none;
      }
  
      .product-container--image,
      .product-container--left-block,
      .product-container--right-block {
        width: 100%;
      }
  
      .product-container--image-desktop {
        display: none;
      }
  
      .product-container--image-mobile {
        display: block;
      }

      .product-list-container--links-title,
      .product-list-container--links-actions {
        display: block;
        margin-bottom: 15px;
        text-align: start;
        width: 100%;
      }

      .product-list-container--link {
        margin-left: 0px;
        margin-right: 15px;
        padding: 8px 10px;
        font-size: 14px;
      }

      .product-list-container--date-cell {
        display: none;
      }

      .product-list-container--title-cell {
        max-width: 115px;
      }

      .notification-container--desktop-links {
        display: none;
      }

      .notification-container--mobile-links {
        display: block;
      }
    }
  </style>
`;